import { Routes, Route } from 'react-router-dom';
import Standard from './pages/Standard';

function App() {
  return (
      <Routes>
        <Route path="/" element={<Standard />} />
      </Routes>
  );
}

export default App;